import { tw } from "@noones/ui/tw";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

export const Header = () => (
    <div
        className={tw.w_full.flex.flex_col.items_center.gap_4.text_center.py_8.max_w_["358px"]
            .md(tw.max_w_full)
            .lg(tw.pt_["188px"].pb_12)}
    >
        <h1 className={tw.my_0.text_title_s.font_bold.lg(tw.text_title_l)}>
            <FormattedMessage
                {...messages.title}
                values={{
                    colored: (c) => <span className={tw.text_green}>{c}</span>,
                }}
            />
        </h1>

        <h3 className={tw.my_0.text_body_16.text_black.lg(tw.text_title_xs)}>
            <FormattedMessage {...messages.description} />
        </h3>
    </div>
);

const messages = defineMessages({
    title: {
        id: "Header.title",
        defaultMessage: "NoOnes <colored>System Status</colored>",
        description: "title",
    },
    description: {
        id: "Header.description",
        defaultMessage: "Stay updated. Stay in control.",
        description: "description",
    },
});
